'use strict';

import {
    addButtonStyling,
    addSelectedCompanyHandler,
    companyGuard,
    getSelectedCompanyForUser,
    pjaxRedirect,
    fnToastrFormError, getDtButtons,
    getSelectedCompany,
} from "../../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../../functions";

export var fnHolidayPayObligationsEntriesTable = function () {
    const tableName = '#datatable-holiday-pay-obligation-entries';

    if (!element_exists(tableName)) return false;

    loadTable();

    addSelectedCompanyHandler(function () {
        pjaxRedirect('/holiday-pay-obligations')
    });


    function loadTable() {
        let $table = $(tableName);
        /*TODO refactor to use method*/
        let selectedCompanyId = getSelectedCompanyForUser();

        if (companyGuard()) {
            $table.parents('.table-responsive').addClass('hidden');
            $table.DataTable().clear().draw();
            return;
        }
        const url = `/${selectedCompanyId}/holiday-pay-obligations/entries/${$table.data('id')}`;

        if ($.fn.dataTable.isDataTable(tableName)) {
            $table.parents('.table-responsive').removeClass('hidden');

            $table.DataTable().ajax.url(url).load(function () {
                setTimeout(function () {
                    $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
                }, 500);
            });
            return;
        }
        const columns = [
            {data: 'id'},
            {
                data: 'employee_name',
                render: function (data, type, row) {
                    /*Open dropzone*/
                    return `${row.employee.first_name} ${row.employee.last_name}`;
                },
            },
            {data: 'employee.department'},
            {
                data: 'days_outstanding',
                render: function (data, type, row) {
                    return localeFormatted(data);
                }
            },
            {
                data: 'basic_salary',
                render: function (data, type, row) {
                    const formattedData = localeFormatted(data);
                    if (!row.calculator) return formattedData;

                    const basicSalary = row.calculator.basic_salary;

                    let tooltipLang = allLangFiles['holiday-pay-obligations'].entries.tooltip.basic_salary;

                    const translationValue = getTranslationValue(tooltipLang, basicSalary);

                    let t = '';
                    for (let i = 0; i < translationValue.length; i++) {
                        let current = translationValue[i];
                        if (i !== (translationValue.length - 1)) {
                            t += `${current.amount} (${current.trans}) <br>+ `
                        } else {
                            t += `${current.amount} (${current.trans})`
                        }
                    }

                    return `<div 
                            data-toggle="tooltip" 
                            class="tooltip-basic_salary" 
                            title="${t}"
                            data-placement="left"
                            >
                            ${formattedData}
                            </div>`;
                },
            },
            {
                data: 'obligation',
                render: function (data, type, row) {
                    const formattedData = localeFormatted(data);
                    if (!row.calculator) return formattedData;

                    let tooltipLang = allLangFiles['holiday-pay-obligations'].entries.tooltip.obligation;

                    const obligation = row.calculator.obligation;
                    return `<span 
                            data-toggle="tooltip" 
                            class="tooltip-obligation" 
                            title="${localeFormatted(obligation.basic_salary)} (${tooltipLang.basic_salary})<br>/ ${obligation.work_days} (${tooltipLang.work_days})<br>* ${localeFormatted(obligation.days_outstanding)} (${tooltipLang.days_outstanding})">
                            ${formattedData}
                            </span>`;
                },
            },
            {
                data: 'last_months_obligation',
                render: function (data, type, row) {
                    return localeFormatted(data);
                },
            },
            {
                data: 'difference',
                render: function (data, type, row) {
                    return localeFormatted(data);
                },
            }
        ];
        /*Rules for filling the columns*/
        const columnDefs = [
            {visible: false, targets: 0, orderable: true},
            {visible: !!$table.data('has-departments'), targets: 3, orderable: true},
        ];

        /*Important otherwise table misaligned*/
        $table.css('width', '100%');


        const dataTable = $table.DataTable({

            language: allLangFiles.datatables,
            rowId: 'id',
            createdRow: function (row, data, dataIndex) {
                if (data.employee.employment_type !== 'App\\Model\\Salary\\CustomerSalariedEmployee') {
                    $(row).addClass('bg-danger');
                    $(row).attr("title", allLangFiles['holiday-pay-obligations'].incorrect_employment);
                    $(row).tooltip({
                        placement: 'left',
                    });
                }
            },
            ajax: {
                url: url,
                dataSrc: function (json) {
                    return json.data;
                },
            },
            columns: columns,
            columnDefs: columnDefs,
            order: [[1, "asc"]],
            scrollX: true,
            lengthMenu: [10, 25, 50, 75, 100],
            initComplete: function (settings, json) {
                $(tableName).parents('.table-responsive').removeClass('hidden');
                dataTable.draw();
            },
            drawCallback: function (settings) {
                $(tableName).parent('.dataTables_scrollBody').css('width', '100%');

                $table.find(".tooltip-basic_salary").tooltip({
                    placement: "left",
                    content: function () {
                        return $(this).prop('title');
                    }
                });
                $table.find(".tooltip-obligation").tooltip({
                    placement: "left",
                    content: function () {
                        return $(this).prop('title');
                    }
                });
            },
        });

        new $.fn.dataTable.Buttons($table.DataTable(), {
                buttons: [
                    {
                        extend: 'excel',
                        exportOptions: {
                            columns: ':visible'
                        },
                    },
                    {
                        extend: 'pdf',
                        exportOptions: {
                            columns: ':visible'
                        },
                        action: function (e, dt, node, config) {
                            const companyId = getSelectedCompanyForUser();
                            const url = `/${companyId}/holiday-pay-obligations/${$table.data('id')}/download`;

                            if (companyGuard()) {
                                return;
                            }
                            getRequestDownload(url);
                        }
                    },
                    {
                        extend: 'csv',
                        exportOptions: {
                            columns: ':visible'
                        },
                    },
                    {
                        extend: 'copy',
                        exportOptions: {
                            columns: ':visible'
                        },
                    },
                    {
                        extend: 'print',
                        exportOptions: {
                            columns: ':visible'
                        },
                    },
                ]
            }
        );
        addButtonStyling($table.DataTable());


    }

    function localeFormatted(number) {
        if (!number) return '0,00';

        return parseFloat(number).toLocaleString('da', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    function getRequestDownload(url) {
        window.location = url;
    }

    function postRequestDownload(url, dt) {
        let entryData = dt.rows({search: 'applied'}).data();
        let entryIds = [];
        for (let i = 0; i < entryData.length; i++) {
            entryIds.push(entryData[i].id);
        }

        const data = {
            entry_ids: entryIds
        };

        // return;
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: function (response) {
                console.log(response);
                const data = response;
                const blob = new Blob([data], {
                    type: 'application/pdf',
                    encoding: "UTF-8"
                });
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = 'test';
                link.click();
            },
            error: fnToastrFormError,
        });
    }

    function getTranslationValue(tooltipLang, basicSalary) {
        return [
            {
                trans: tooltipLang.salary,
                amount: localeFormatted(basicSalary.salary)
            },
            {
                trans: tooltipLang.fixed_add_ons,
                amount: localeFormatted(basicSalary.fixed_add_ons)
            },
            {
                trans: tooltipLang.company_pension,
                amount: localeFormatted(basicSalary.company_pension)
            },
            {
                trans: tooltipLang.free_car_monthly,
                amount: localeFormatted(basicSalary.free_car_monthly)
            },
            {
                trans: tooltipLang.free_phone_monthly,
                amount: localeFormatted(basicSalary.free_phone_monthly)
            },
            {
                trans: tooltipLang.health_insurance_monthly,
                amount: localeFormatted(basicSalary.health_insurance_monthly)
            },
            {
                trans: tooltipLang.company_atp,
                amount: localeFormatted(basicSalary.company_atp)
            }
        ];
    }
};
